import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';
import {CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule } from "@angular/forms";

import {RxFormsModule} from "@rx/forms";
import {RxViewModule} from "@rx/view";
import {    RxTableModule} from "@rx/table";

import { CallRecordHistoryListComponent } from './call-record-history-list.component'
import { CALL_RECORD_HISTORY_LIST_ROUTING } from './call-record-history-list.routing'
import {CallRecordHistoryService } from "../call-record-history.service";
import { CallDbSharedComponentModule } from '../../call-db/call-db-shared-component.module';
import { CallRecordHistorySharedComponentModule } from '../call-record-history-shared-component.module';

@NgModule({
    imports: [
        CALL_RECORD_HISTORY_LIST_ROUTING ,
        CommonModule, RxViewModule, RxTableModule, RxFormsModule, FormsModule, ReactiveFormsModule,CallDbSharedComponentModule
        ,CallRecordHistorySharedComponentModule],
    declarations: [CallRecordHistoryListComponent ],
    exports: [RouterModule],
    providers: [CallRecordHistoryService]
})
export class CallRecordHistoryListModule { }